import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
// import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import rootReducer from './root-reducer';

const configureStoreProd = (initialState) => {
  const middlewares = [
    // Add other middleware on this line...

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    thunk,
  ];

  return createStore(rootReducer, initialState, compose(applyMiddleware(...middlewares)));
};

const configureStoreDev = (initialState) => {
  const middlewares = [
    // Add other middleware on this line...

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    thunk,
    // Redux middleware that spits an error on you when you try to
    // mutate your state either inside a dispatch or between dispatches.
    // reduxImmutableStateInvariant(),
  ];

  // add support for Redux dev tools
  const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middlewares)));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./root-reducer', () => {
      store.replaceReducer(rootReducer(history));
    });
  }

  return store;
};

const configureStore = process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev;

export default configureStore;
